var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MediaDetail"},[(_vm.detail.bookType === 2)?_c('iframe',{key:_vm.detail.id,staticClass:"word",attrs:{"src":(_vm.iframeUrl + "&furl=" + (_vm.detail.bookHref || ''))}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }